import { t } from "@lingui/macro";
import { useAtomValue } from "jotai";

import { getDiningPartySize } from "@/features/BookingWizard/DiningBookingWizard/atoms/selectors/getDiningPartySize/getDiningPartySize";
import { DiningBookingKnownPeopleAtom } from "@/features/BookingWizard/DiningBookingWizard/atoms/stores";
import { Avatar } from "@whoosh/design-system/src/components/display";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

export const DiningBookingKnownPeopleDisplay = () => {
  const knownPeople = useAtomValue(DiningBookingKnownPeopleAtom);

  const partySize = useAtomValue(getDiningPartySize);
  const remainingCapacity = Math.max(partySize - knownPeople.length, 0);
  const showCondensedView = partySize > 6;

  return (
    <HStack
      px={5}
      py={4}
      alignItems="center"
      justifyContent="flex-start"
      gap={2}
      borderBottomWidth={1}
      borderColor="outline-default"
      bg="surface-primary"
      flexWrap="wrap"
    >
      {showCondensedView ? (
        <HStack alignItems="center" gap={2}>
          <Avatar size="sm" type="unknownCustomer" />
          <Text variant="mainBaseSemiBold">
            {remainingCapacity}{" "}
            {remainingCapacity === 1 ? t`Available spot` : t`Available spots`}
          </Text>
        </HStack>
      ) : (
        <>
          {knownPeople.map((person) => (
            <Avatar
              key={person.playerId}
              profileImagePublicId={person.profileImagePublicId ?? undefined}
              firstName={person.firstName}
              lastName={person.lastName}
              size="sm"
              type={person.type === "Member" ? "member" : "guest"}
            />
          ))}
          {Array.from({ length: remainingCapacity }).map((_, index) => (
            <Avatar key={index} size="sm" type="empty" />
          ))}
        </>
      )}
    </HStack>
  );
};
